module.exports = __webpack_public_path__ + "img/L_315_0.cbe72fd8.png";